angular.module('app').directive('campanhaGaleria', function ($http, $timeout) {
    return {
        restrict: 'E',
        templateUrl: '/html/campanha-galeria.html?v=' + angular.element('meta[name="version-id"]').attr('content'),
        scope: {
            vitrines: '=',
        },
        controller: ['$scope', '$timeout', function ($scope, $timeout) {
                $scope.options = {
                    loop: true,
                    items: 1,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true,
                    video: true,
    
                }
    
                $scope.init = function (el) {
                    if (!window.YTVideos) {
                        window.YTVideos = new Videos();
                    }
    
                    $(el).find('.youtube-player-container').each(function () {
                        window.YTVideos.add($(this))
                    });
    
                    $(window).ready(function () {
                        window.YTVideos.loadApi();
                    });
    
                }
            }
        ],
        link: function ($scope, $element) {


            $scope.$watch($scope.vitrines, function (newValue) {
                $timeout(function () {
                    $scope.init($element);
                }, 1000);

            }, true);

        }
    };
});